module.exports = __webpack_public_path__ + "static/media/hearts.f5285120.svg";